const ALLOWED_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';

export function generateCodeVerifier(length = 64) {
  if (length < 43) length = 43;
  if (length > 128) length = 128;

  const randomBytes = new Uint8Array(length);
  crypto.getRandomValues(randomBytes);

  let verifier = '';
  for (let i = 0; i < length; i++) {
    verifier += ALLOWED_CHARS[randomBytes[i] % ALLOWED_CHARS.length];
  }
  return verifier;
}

export async function generateCodeChallenge(codeVerifier) {
  const encoded = new TextEncoder().encode(codeVerifier);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);

  const bytes = new Uint8Array(hashBuffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function generateState() {
  const randomBytes = new Uint8Array(16);
  crypto.getRandomValues(randomBytes);
  return Array.from(randomBytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
